import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "stage", "status", "contrast", "color", "title", "subtitle", "tagline",
    "titleOut", "subtitleOut", "taglineOut", "note", "noteOut", "badgeOut",
    "cover", "coverWrap", "logo", "kit", "size"
  ]
  static values = { defaults: Object }

  connect() {
    this.sync()
  }

  sync() {
    this.colorTargets.forEach((input) => {
      const name = input.dataset.var
      if (name && this.hasStageTarget) this.stageTarget.style.setProperty(name, input.value)
    })

    if (this.hasTitleOutTarget) this.titleOutTarget.textContent = this.titleTarget?.value || ""
    if (this.hasSubtitleOutTarget) this.subtitleOutTarget.textContent = this.subtitleTarget?.value || ""
    if (this.hasTaglineOutTarget) this.taglineOutTarget.textContent = this.taglineTarget?.value || ""
    if (this.hasNoteOutTarget) {
      this.noteOutTarget.textContent = this.noteTarget?.value?.trim() || "Preços e itens sujeitos a alteração"
    }

    const badge = this.element.querySelector('[name="account[show_mca_badge]"][type="checkbox"]')
    if (badge && this.hasBadgeOutTarget) {
      this.badgeOutTarget.hidden = !badge.checked
    }

    const kit = this.hasKitTarget && this.kitTargets.find((el) => el.checked)
    if (kit && this.hasStageTarget) {
      this.stageTarget.style.setProperty("--menu-font-heading", kit.dataset.heading)
      this.stageTarget.style.setProperty("--menu-font-body", kit.dataset.body)
      this.stageTarget.style.setProperty("--menu-heading-weight", kit.dataset.headingWeight)
      this.stageTarget.style.setProperty("--menu-heading-transform", kit.dataset.headingTransform)
      this.stageTarget.style.setProperty("--menu-heading-tracking", kit.dataset.headingTracking)

      const fonts = document.getElementById("theme-kit-fonts")
      if (fonts && kit.dataset.fontsUrl) fonts.href = kit.dataset.fontsUrl
    }

    if (this.hasStageTarget) {
      this.sizeTargets.filter((el) => el.checked).forEach((el) => {
        let vars = {}
        try { vars = JSON.parse(el.dataset.vars || "{}") } catch {}
        Object.entries(vars).forEach(([name, value]) => {
          this.stageTarget.style.setProperty(name, value)
        })
      })
    }

    this.previewFiles()
    this.checkContrast()
  }

  previewFiles() {
    const cover = this.element.querySelector('[name="theme[cover_image]"]')
    const logo = this.element.querySelector('[name="theme[logo]"]')
    this.previewFile(cover, this.hasCoverTarget ? this.coverTarget : null, this.hasCoverWrapTarget ? this.coverWrapTarget : null)
    this.previewFile(logo, this.hasLogoTarget ? this.logoTarget : null)
  }

  previewFile(input, image, wrap) {
    const file = input?.files?.[0]
    if (!file || !image) return
    image.src = URL.createObjectURL(file)
    image.classList.remove("hidden")
    wrap?.classList.remove("hidden")
    wrap?.closest(".menu-cover")?.classList.add("menu-cover--media")
  }

  restore() {
    const defaults = this.defaultsValue
    this.colorTargets.forEach((input) => {
      const key = input.name?.match(/\[(\w+)\]/)?.[1]
      if (key && defaults[key]) {
        input.value = defaults[key]
        input.dispatchEvent(new Event("input", { bubbles: true }))
      }
    })
    this.sync()
  }

  saved(event) {
    if (!event.detail?.success || !this.hasStatusTarget) return
    this.statusTarget.textContent = "Salvo"
    window.clearTimeout(this._savedTimer)
    this._savedTimer = window.setTimeout(() => { this.statusTarget.textContent = "" }, 2000)
  }

  checkContrast() {
    if (!this.hasContrastTarget) return
    const bg = this.valueOf("color_background")
    const fg = this.valueOf("color_text")
    const primary = this.valueOf("color_primary")
    const muted = this.valueOf("color_muted")
    const fail = [ [fg, bg], [primary, bg], [muted, bg] ].some(([a, b]) => this.ratio(a, b) < 4.5)
    this.contrastTarget.hidden = !fail
  }

  valueOf(attr) {
    const input = this.colorTargets.find((el) => el.name === `theme[${attr}]`)
    return input?.value
  }

  ratio(a, b) {
    if (!a || !b) return 21
    const L1 = this.luminance(a)
    const L2 = this.luminance(b)
    const [hi, lo] = L1 > L2 ? [L1, L2] : [L2, L1]
    return (hi + 0.05) / (lo + 0.05)
  }

  luminance(hex) {
    const n = hex.replace("#", "")
    if (n.length !== 6) return 0
    const rgb = [0, 2, 4].map((i) => {
      let c = parseInt(n.slice(i, i + 2), 16) / 255
      return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4
    })
    return 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]
  }
}
